export const navItems = [
  { label: 'หน้าแรก', path: '/' },
  { label: 'Forex พื้นฐาน', path: '/forex-basics' },
  { label: 'คำศัพท์ Forex', path: '/glossary' },
  { label: 'วิธีเทรด Forex', path: '/forex-trading' },
  { label: 'MT4 / MT5', path: '/mt4-mt5' },
  { label: 'วิเคราะห์ Forex', path: '/forex-analysis' },
  { label: 'การบริหารความเสี่ยง', path: '/risk-management' },
];

export const learningPath = [
  {
    no: '01',
    title: 'เข้าใจ Forex',
    desc: 'รู้จักตลาดแลกเปลี่ยนเงินตราและสิ่งที่เรากำลังซื้อขายจริง ๆ',
    path: '/what-is-forex',
  },
  {
    no: '02',
    title: 'เรียนรู้คำศัพท์',
    desc: 'เริ่มจาก Pip หน่วยวัดราคาที่ใช้ทุกวัน แล้วค่อยต่อด้วย Spread, Leverage และ Margin',
    path: '/what-is-pip',
  },
  {
    no: '03',
    title: 'อ่านกราฟ',
    desc: 'เริ่มอ่านแท่งเทียน แนวรับแนวต้าน และสัญญาณจากอินดิเคเตอร์',
    path: '/forex-technical-analysis',
  },
  {
    no: '04',
    title: 'ฝึกเทรด',
    desc: 'วางแผนและเปิดออเดอร์ตามขั้นตอนจริง ตั้งแต่เลือกคู่เงินจนปิดสถานะ',
    path: '/how-to-trade-forex',
  },
  {
    no: '05',
    title: 'บริหารความเสี่ยง',
    desc: 'กำหนดความเสี่ยงต่อออเดอร์และขนาดสถานะให้พอดีกับพอร์ต',
    path: '/risk-management-basics',
  },
];

export const basicsCards = [
  {
    title: 'Forex คืออะไร?',
    desc: 'ทำความเข้าใจตลาด Forex และการซื้อขายสกุลเงิน',
    slug: '/what-is-forex',
    index: '01',
    icon: 'ri-global-line',
    minutes: 5,
    points: ['ตลาดแลกเปลี่ยนเงินตราทำงานอย่างไร', 'ใครบ้างที่ขับเคลื่อนราคา Forex'],
  },
  {
    title: 'คู่เงินคืออะไร?',
    desc: 'เรียนรู้ Major, Minor และ Exotic Pairs',
    slug: '/currency-pairs',
    index: '02',
    icon: 'ri-swap-line',
    minutes: 6,
    points: ['ความหมายของ Base และ Quote Currency', 'คู่เงินยอดนิยมที่มือใหม่ควรรู้จัก'],
  },
  {
    title: 'Pip คืออะไร?',
    desc: 'เข้าใจหน่วยการเปลี่ยนแปลงของราคา',
    slug: '/what-is-pip',
    index: '03',
    icon: 'ri-ruler-2-line',
    minutes: 4,
    points: ['วิธีนับ Pip และ Pipette', 'คำนวณมูลค่าต่อ Pip ของแต่ละคู่'],
  },
  {
    title: 'Spread คืออะไร?',
    desc: 'เรียนรู้ส่วนต่างระหว่างราคา Bid และ Ask',
    slug: '/what-is-spread',
    index: '04',
    icon: 'ri-arrow-left-right-line',
    minutes: 4,
    points: ['ทำไมราคา Bid กับ Ask ต่างกัน', 'Spread กว้าง-แคบส่งผลต่อต้นทุนอย่างไร'],
  },
  {
    title: 'Leverage คืออะไร?',
    desc: 'ทำความเข้าใจ Leverage และความเสี่ยง',
    slug: '/what-is-leverage',
    index: '05',
    icon: 'ri-rocket-2-line',
    minutes: 5,
    points: ['ขยายขนาดออเดอร์ด้วยเงินประกันน้อยลง', 'ความเสี่ยงที่มาพร้อมกับ Leverage สูง'],
  },
  {
    title: 'Margin คืออะไร?',
    desc: 'เรียนรู้เงินประกันที่ใช้ในการเปิดสถานะ',
    slug: '/what-is-margin',
    index: '06',
    icon: 'ri-shield-check-line',
    minutes: 5,
    points: ['Free Margin และ Used Margin ต่างกันอย่างไร', 'Margin Call เกิดขึ้นเมื่อไหร่'],
  },
];

export const tradingSteps = [
  {
    no: '01',
    title: 'เลือกคู่เงิน',
    desc: 'เริ่มจากคู่เงินที่สภาพคล่องสูงและสเปรดแคบ เช่น EUR/USD, GBP/USD หรือ XAU/USD เพื่อให้เข้าและออกออเดอร์ได้ง่ายในทุกสภาวะตลาด มือใหม่ควรโฟกัสเพียง 1-2 คู่ก่อน เพื่อให้คุ้นเคยกับพฤติกรรมและจังหวะการเคลื่อนไหวของราคาอย่างแท้จริง',
    accent: false,
  },
  {
    no: '02',
    title: 'วิเคราะห์ตลาด',
    desc: 'อ่านแนวโน้มของกราฟตั้งแต่ไทม์เฟรมใหญ่ลงมาเล็ก แล้วหาจุดเข้า แนวรับแนวต้าน และโซนที่ราคามักหยุดหรือกลับตัว หลีกเลี่ยงการเทรดสวนเทรนด์ และควรรอสัญญาณยืนยันให้ชัดเจนก่อนตัดสินใจ เพื่อลดการเข้าออเดอร์จากความคาดเดา',
    accent: false,
  },
  {
    no: '03',
    title: 'กำหนดขนาดการเทรด',
    desc: 'คำนวณขนาด Lot จากระยะ Stop Loss และความเสี่ยงที่รับได้ต่อออเดอร์ เช่น ไม่เกิน 1% ของพอร์ต การกำหนดขนาดที่พอดีช่วยให้แม้แพ้ติดกันหลายไม้ก็ยังไม่กระทบเงินทุน และทำให้ตัดสินใจได้อย่างมีวินัยมากขึ้น',
    accent: true,
  },
  {
    no: '04',
    title: 'เปิดออเดอร์',
    desc: 'เลือกคำสั่ง Buy หรือ Sell พร้อมกำหนดราคาเข้าที่ต้องการและขนาดออเดอร์ให้ตรงกับที่วางแผนไว้ ควรตรวจสอบราคาปัจจุบันและสเปรดก่อนกดยืนยัน เพื่อไม่ให้ต้นทุนจริงต่างจากที่คำนวณไว้ และเริ่มจากออเดอร์เล็ก ๆ ในช่วงแรก',
    accent: false,
  },
  {
    no: '05',
    title: 'ตั้ง Stop Loss และ Take Profit',
    desc: 'วางจุดตัดขาดทุนและจุดทำกำไรทันทีหลังเปิดออเดอร์ โดยอิงจากโครงสร้างราคาและสัดส่วน Risk/Reward ที่ยอมรับได้ เช่น 1:2 การตั้งไว้ล่วงหน้าช่วยให้ไม่ต้องตัดสินใจตอนตลาดผันผวน และล็อกความเสี่ยงให้อยู่ในกรอบที่ควบคุมได้เสมอ',
    accent: true,
  },
  {
    no: '06',
    title: 'ติดตามและปิดออเดอร์',
    desc: 'ติดตามสถานะอย่างสม่ำเสมอและปิดออเดอร์ตามแผนที่ตั้งไว้ ไม่เลื่อน Stop Loss หรือ Take Profit ด้วยอารมณ์ เมื่อจบออเดอร์แล้วควรจดบันทึกผลลัพธ์และสิ่งที่ทำได้ดีหรือผิดพลาด เพื่อนำมาปรับปรุงแผนการเทรดในครั้งถัดไป',
    accent: false,
  },
];

export const platformGuides = [
  {
    name: 'MT4',
    full: 'MetaTrader 4',
    desc: 'แพลตฟอร์มยอดนิยมสำหรับเทรด Forex ที่ใช้งานง่ายและเบา เหมาะกับมือใหม่',
    accent: false,
    chart: 'mt4',
    symbol: 'EUR/USD',
    timeframe: 'H1',
    items: [
      'วิธีติดตั้ง MT4',
      'วิธีเปิดกราฟ',
      'วิธีเพิ่มคู่เงิน',
      'วิธีเปิดออเดอร์',
      'วิธีตั้ง Stop Loss',
      'วิธีตั้ง Take Profit',
    ],
    path: '/mt4-guide',
  },
  {
    name: 'MT5',
    full: 'MetaTrader 5',
    desc: 'แพลตฟอร์มรุ่นใหม่ที่รองรับเครื่องมือวิเคราะห์และสินทรัพย์หลากหลายขึ้น',
    accent: true,
    chart: 'mt5',
    symbol: 'EUR/USD',
    timeframe: 'M15',
    items: [
      'วิธีติดตั้ง MT5',
      'วิธีเปิดกราฟ',
      'วิธีเพิ่มคู่เงิน',
      'วิธีเปิดออเดอร์',
      'วิธีตั้ง Stop Loss',
      'วิธีตั้ง Take Profit',
    ],
    path: '/mt5-guide',
  },
];

export const analysisModules = [
  {
    title: 'Price Action',
    desc: 'เรียนรู้พฤติกรรมราคา การอ่านแท่งเทียน และโครงสร้างตลาดโดยไม่ต้องพึ่งอินดิเคเตอร์',
    tags: ['แท่งเทียน', 'โครงสร้างตลาด'],
  },
  {
    title: 'Technical Indicators',
    desc: 'ทำความรู้จักเครื่องมือยอดนิยมอย่าง RSI, MACD และ Moving Average พร้อมวิธีอ่านค่า',
    tags: ['RSI', 'MACD', 'Moving Average'],
  },
  {
    title: 'Support & Resistance',
    desc: 'เรียนรู้แนวรับและแนวต้าน จุดที่ราคามักหยุดหรือกลับตัว เพื่อวางแผนเข้าและออก',
    tags: ['แนวรับ', 'แนวต้าน'],
  },
];

export const indicatorReadings = [
  { label: 'RSI (14)', value: '58.4', note: 'โซนกลาง ยังมีแรงซื้อ', trend: 'up' },
  { label: 'MACD (12,26)', value: '+0.0021', note: 'เส้นสัญญาณตัดขึ้น', trend: 'up' },
  { label: 'EMA 50', value: '1.0795', note: 'ราคายืนเหนือเส้นค่าเฉลี่ย', trend: 'up' },
  { label: 'Stochastic (14)', value: '72.6', note: 'เริ่มเข้าขตซื้อมากเกิน', trend: 'down' },
];

export const faqItems = [
  {
    q: 'มือใหม่เรียน Forex ยากไหม?',
    a: 'ไม่ยากเกินไปหากเริ่มจากพื้นฐานให้เป็นระบบ ช่วงแรกมีเพียงไม่กี่เรื่องที่ต้องเข้าใจจริง ๆ คือ คู่เงินคืออะไร Pip นับอย่างไร Spread เป็นต้นทุนแบบไหน และ Leverage กับ Margin ส่งผลต่อพอร์ตอย่างไร ถ้าเข้าใจสี่เรื่องนี้ก่อน เนื้อหาส่วนที่เหลืออย่างการอ่านกราฟและการตั้งคำสั่งจะต่อยอดได้เร็วขึ้นมาก',
    a2: 'สิ่งที่ทำให้มือใหม่รู้สึกว่ายากมักไม่ใช่ตัวเนื้อหา แต่คือการข้ามขั้น เช่น เริ่มดูอินดิเคเตอร์ทั้งที่ยังไม่รู้ว่า Pip คิดเป็นเงินเท่าไร หรือเปิดออเดอร์จริงก่อนผ่านบัญชีทดลอง แนวทางที่ช้าที่สุดแต่ได้ผลคือใช้เวลาราว 4-6 สัปดาห์อ่านพื้นฐานให้จบ แล้วฝึกบนบัญชีทดลองอย่างน้อย 3 เดือนหรือราว 50-100 ออเดอร์ ก่อนตัดสินใจใช้เงินจริง',
  },
  {
    q: 'ต้องใช้เงินเท่าไหร่ในการเริ่มเทรด?',
    a: 'หลายโบรกเกอร์เปิดบัญชีขั้นต่ำได้ตั้งแต่หลักสิบดอลลาร์ หรือประมาณ 500-3,000 บาท แต่ตัวเลขนั้นไม่ใช่คำตอบที่สำคัญเท่าขนาดความเสี่ยงที่คุณรับได้จริง ถ้าพอร์ตมี 1,000 ดอลลาร์และกำหนดความเสี่ยงต่อออเดอร์ไว้ 1% แปลว่ายอมเสียได้ไม้ละ 10 ดอลลาร์ ซึ่งเพียงพอสำหรับเทรด 0.05 lot ด้วย Stop Loss 20 pip บน EUR/USD',
    a2: 'เงินทุนที่เล็กเกินไปทำให้แทบเป็นไปไม่ได้ที่จะบริหารความเสี่ยงให้ถูกต้อง เพราะ Lot ขั้นต่ำ 0.01 บนพอร์ต 50 ดอลลาร์ที่ตั้ง Stop Loss 100 pip ก็กินความเสี่ยงเกินพอร์ตไปแล้ว จึงควรเริ่มจากจำนวนเงินที่เปิดออเดอร์ได้ตามแผนจริง และเป็นเงินที่หายไปแล้วไม่กระทบค่าใช้จ่ายในชีวิตประจำวัน',
  },
  {
    q: 'ต้องมีพื้นฐานด้านการเงินมาก่อนไหม?',
    a: 'ไม่จำเป็นเลย บทความในเว็บนี้เริ่มตั้งแต่ระดับศูนย์ ตั้งแต่ Forex คืออะไร ไปจนถึงการเปิดออเดอร์จริงบน MT4 / MT5 สิ่งที่ต้องมีคือความสม่ำเสมอในการเรียนรู้และวินัยในการทำตามแผน ไม่ใช่ปริญญาด้านการเงิน',
    a2: 'หากมีเวลาวันละ 30-45 นาที การอ่านพื้นฐานให้จบทั้งหมวดมักใช้เวลาประมาณ 2-3 สัปดาห์ สิ่งที่ควรรู้ล่วงหน้ามีเพียงการบวกลบคูณหารและความเข้าใจว่าราคาเคลื่อนที่เพราะมีคนซื้อขาย ไม่ต้องคำนวณดอกเบี้ยทบต้นหรืออ่านงบการเงินเป็นก็เริ่มได้',
  },
  {
    q: 'ใช้เวลานานแค่ไหนกว่าจะเทรดเป็น?',
    a: 'ไม่มีคำตอบตายตัว ขึ้นอยู่กับเวลาและความสม่ำเสมอของแต่ละคน โดยทั่วไปผู้เรียนใช้เวลาหลายสัปดาห์ถึงหลายเดือนในการทำความเข้าใจพื้นฐาน และใช้เวลาอีกหลายเดือนในการฝึกให้ทำตามแผนได้จริงทุกไม้ เพราะการเทรดเป็นทักษะที่ต้องสะสมประสบการณ์ ไม่ใช่ความรู้ที่อ่านจบแล้วจบเลย',
    a2: 'ตัวชี้วัดที่ใช้ได้ดีกว่าจำนวนเดือนคือจำนวนออเดอร์ที่บันทึกไว้ หากคุณจดเหตุผลเข้า ระดับ Stop Loss และผลลัพธ์ครบ 50-100 ไม้ แล้วพบว่าทำตามแผนได้มากกว่า 80% ของจำนวนไม้ นั่นคือสัญญาณว่าพร้อมขยับไปใช้เงินจริงด้วยขนาดที่เล็กก่อน',
  },
  {
    q: 'เลือกโบรกเกอร์ควรดูอะไรบ้าง นอกจากสเปรดถูก?',
    a: 'สเปรดเป็นเพียงต้นทุนส่วนหนึ่ง สิ่งที่ควรตรวจคู่กันคือค่าคอมมิชชัน ค่าสวอปเมื่อถือข้ามคืน และระยะ Stop Loss ขั้นต่ำ เพราะโบรกเกอร์ที่สเปรดแคบแต่คิดค่าคอมมิชชันต่อ Lot สูงอาจแพงกว่าที่คิดเมื่อเทรดถี่ ๆ ส่วนผู้ที่ถือออเดอร์ข้ามคืนควรดูค่าสวอปเป็นหลัก',
    a2: 'อีกสองเรื่องที่ควรเช็กก่อนฝากเงินคือการกำกับดูแลและขั้นตอนถอนเงิน ว่าโบรกเกอร์อยู่ภายใต้หน่วยงานกำกับใด ใช้เวลาถอนกี่วัน และมีค่าธรรมเนียมถอนหรือไม่ การทดลองถอนจำนวนเล็กน้อยตั้งแต่ต้นเป็นวิธีที่ตรงที่สุด และควรเลือกโบรกเกอร์ที่มีบัญชีทดลองให้ฝึกก่อนโดยไม่ต้องฝากเงิน',
  },
  {
    q: 'บัญชีทดลองควรฝึกนานแค่ไหนก่อนใช้เงินจริง?',
    a: 'ไม่มีเกณฑ์ตายตัว แต่ควรฝึกจนทำครบทุกขั้นตอนได้เองโดยไม่ต้องเปิดคู่มือ ได้แก่ คำนวณ Lot จากความเสี่ยง ตั้ง Stop Loss และ Take Profit ปิดออเดอร์บางส่วน และบันทึกผลลงสมุดเทรด ประมาณว่าใช้เวลาราว 2-3 เดือนหรือ 50 ออเดอร์ขึ้นไปจึงจะเริ่มคล่อง',
    a2: 'ข้อจำกัดของบัญชีทดลองคือไม่มีอารมณ์เข้ามาเกี่ยวข้อง คำสั่งอาจไม่ได้ถูกส่งเข้าตลาดจริง และราคาที่ได้จึงไม่ใช่ราคาที่คุณจะได้รับทั้งหมด ดังนั้นเมื่อเริ่มใช้เงินจริงควรลดขนาด Lot ลงเหลือประมาณ 0.01-0.05 และถือว่างวดแรกคือการฝึกเรื่องวินัย ไม่ใช่การทำกำไร',
  },
];

export const riskMetrics = [
  { label: 'Risk per Trade', value: '1.0%', desc: 'ความเสี่ยงต่อออเดอร์ที่แนะนำสำหรับมือใหม่', tone: 'primary' },
  { label: 'Stop Loss', value: '25 pips', desc: 'ระยะตัดขาดทุนที่วางไว้ล่วงหน้าอย่างชัดเจน', tone: 'accent' },
  { label: 'Position Size', value: '0.10 lot', desc: 'ขนาดสถานะที่คำนวณจากความเสี่ยงและ Stop Loss', tone: 'primary' },
  { label: 'Risk / Reward', value: '1 : 2', desc: 'ยอมเสี่ยง 1 เพื่อโอกาสทำกำไร 2 เท่า', tone: 'accent' },
  { label: 'Drawdown', value: '6.4%', desc: 'ระดับพอร์ตย้อนกลับจากจุดสูงสุดที่รับได้', tone: 'primary' },
];